<template>
    <div class="modal fade modal-custom" id="review" tabindex="-1" role="dialog" aria-labelledby="review"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-custom__content">
                <div class="modal-custom__header">
    
                    <img class="img-u" src="@/assets/images/u.svg" />
                    <img class="img-sr" src="@/assets/images/sr.svg" />
    
                    <span class="text-header">
                        Welcome to <span>My Unitel</span>
                        and service satisfaction survey system
                    </span>
                    <span class="modal-custom__action" data-bs-dismiss="modal" @click="resetForm">
                        <i class="icon-fonts icon-fonts--close"></i>
                    </span>
                </div>
    
                <div class="modal-custom__body">
                    <div class="review-process">
    
                        <p class="rating-vote__des mt-2">
                            {{ $t('Please know the level of Customer Satisfaction with My Unitel') }}
                        </p>
    
    
    
                        <!-- Rating vote -->
                        <div class="rating-vote">
                            <span class="rating-vote__action">
                                <i class="icon-fonts icon-fonts--star-2" :class="{ active: numberStars >= index + 1 }"
                                    v-for="(item, index) in listRate" :key="index"
                                    @click="handleClickStar(index + 1, item)">
                                    <span  :class="{ active: numberStars == index + 1 }" class="text-star">{{ item.name
                                        }}</span></i>
                            </span>
                        </div>
                        <hr class="mt-3">
    
                        <!-- Danh sách gợi ý -->
                        <ul class="review-process__list">
                            <li class="review-process__item" v-for="(item, index) in listSuggest" :key="index"
                                :class="{ selected: textSuggestCode.includes(item?.textSuggestCode) }"
                                @click="handleClickSuggest(item)">
    
                                <!-- <span class="review-process__tick"> -->
                                <i class="icon-fonts icon-fonts--tick review-process__tick"
                                    v-if="textSuggestCode.includes(item?.textSuggestCode)">
                                </i>
                                <!-- </span> -->
    
                                <span class="review-process__value">{{ item?.textSuggestName }}</span>
                            </li>
                        </ul>
                    </div>
    
    
    
    
                    <div v-if="isShowReview" class="review-process__form">
                        <div class="form-customize">
                            <textarea class="form-control" :placeholder="$t('Please share your comments about the product...')"
                                v-model.trim="comment" maxlength="160"></textarea>
                        </div>
                    </div>
                    <div class="review-process__btn">
                        <button class="button button--primary" @click="handleSubmit" :disabled="!numberStars">
                            {{ $t('ftth.error_process.submit') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import BaseComponent from '@/mixins/BaseComponent'
import service from '@/modules/mobile/services/MobileService'
import LocalStorage from '@/ultils/local-storage'
import { bus } from '@/main.js'
import $ from 'jquery'

export default {
  name: 'RateModal',
  mixins: [BaseComponent],
  components: {},
  props: { isList: Boolean },
  data() {
    return {
      // listRate: null,
      // listSuggest: null,
      comment: '',


      listRate: [],     // Danh sách số sao
      listSuggest: [],  // Danh sách gợi ý đánh giá
      numberStars: 0,   // Số sao được chọn
      idStars: 0,   // Số sao được chọn
      textSuggestCode: [], // Danh sách gợi ý đã chọn
      isShowReview: false
    }
  },
  created() {
    // bus.$emit('addCachedComponents', 'RateModal')
    // this.getData()

    this.getDataRate()

  },

  computed: {
    errorReportItem() {
      return this.$store.state.errorReportItem
    },


  },
  methods: {
    handleClickSuggest(item) {


      let index = item.textSuggestCode;
      // Nếu đã chọn, bỏ chọn nó
      if (this.textSuggestCode.includes(index)) {
        this.textSuggestCode = [];
      } else {
        // Chỉ giữ lại một giá trị duy nhất
        this.textSuggestCode = [index];
      }


      this.isShowReview =  item.active;
      this.comment = '';
    },
    // Khi click vào số sao
    handleClickStar(index, item) {
      this.idStars = item.numberStarsId
      this.numberStars = index;

      // Lấy danh sách gợi ý theo số sao được chọn
      this.listSuggest = this.listRate.find(rate => rate.value === index)?.listTextSuggestDTO || [];

      // Reset danh sách gợi ý đã chọn
      this.textSuggestCode = [];

      this.isShowReview = false
    },
    closeRate() {
      $(`#review`).trigger('click')
      this.resetForm()
    },
    resetForm() {
      this.numberStars = this.listRate?.length
      this.textSuggestCode = []
      this.comment = ''
      this.idStars = 0
      let length = this.listRate?.length;


      this.handleClickStar(length, this.listRate[length - 1]);

      //   store.commit('setListSuggest', this.listRate[this.listRate?.length - 1]?.listTextSuggestDTO || [])
    },
    goBack() {
      this.$router.push('/home')
    },
    async handleSubmit() {
      this.showLoading()
      let userInfo = JSON.parse(LocalStorage.getItem('user_info'))
      const params = {
        isdn: userInfo?.isdn,
        language: LocalStorage.getItem('lang'),
        problemId: this.errorReportItem?.problemId,
        number_star_value: this.numberStars,
        number_star: this.idStars,
        suggest_id: this.textSuggestCode[0],
        detail: this.comment
      }
      await service
        // .getProblems(params)
        .setStarsTextSuggestOfSurvey(params)
        .then((res) => {
          // console.log('evaluateNVKT', res);
          if (res.errorCode === '0') {
            this.$store.dispatch('setNotification', {
              content: res.userMsg ?? res.message,
              icon: './images/ic-success.svg'
            })
            bus.$emit('clearCachedComponents', 'FTTHReportError')
            // Gọi lại api list sau khi rate thành công nếu ở màn List
            if (this.isList) {
              this.$emit('getList')
            } else {
              // Nếu ở màn detail thì back về màn list
              this.goBack()
            }
          } else {
            this.$store.dispatch('setNotification', { content: res.userMsg ?? res.message })
          }
        })
        .finally(() => {
          this.hideLoading()
          this.closeRate()
        })
    },
    async getDataRate() {
      console.log('getDataRate is running...');
      this.showLoading();

      let lang = LocalStorage.getItem('langV2') || 'en';

      try {
        let userInfo = JSON.parse(LocalStorage.getItem('user_info'));
        const params = {
          isdn: userInfo?.isdn,
          language: LocalStorage.getItem('lang')
        };

        const lg = LocalStorage.getItem('lang')
        if (lg == 'vi' || lg == 'vn') {
          lang = 'vn'
        } else if (lg == 'lc' || lg == 'lo') {
          lang = 'lc'
        } else if (lg == 'zh' || lg == 'cn') {
          lang = 'cn'
        }
        // Gọi API
        const res = await service.getStarsTextSuggestOfSurvey(params);

        if (res?.errorCode === "0" && res?.wsResponse) {
          const data = res.wsResponse;

          // Lưu số sao (rating)
          // Lưu số sao (rating) và gợi ý của mỗi sao
          this.listRate = (data && Array.isArray(data) ? data : []).map(item => ({
            value: item.value, // Số sao
            name: item.name?.[lang] || '', // Tên sao, mặc định là chuỗi rỗng nếu không tồn tại
            numberStarsId: item.numberStarsId, // Tên sao
            listTextSuggestDTO: (item.suggests && Array.isArray(item.suggests) ? item.suggests : []).map(suggest => ({
              textSuggestCode: suggest.textSuggestId,
              active: suggest.active,
              textSuggestName: suggest.textSuggestName?.[lang] || '' // Mặc định là chuỗi rỗng nếu không tồn tại
            })) // Lưu danh sách gợi ý theo sao
          }));

          let length = this.listRate?.length;


          this.handleClickStar(length, this.listRate[length - 1]);

          console.log(this.listRate, this.listSuggest);

        } else {
          console.error("Lỗi API:", res?.errorMessage);
        }
      } catch (error) {
        console.error("Lỗi khi gọi API:", error);
      } finally {
        this.hideLoading();
      }
    },
  },
  watch: {}
}
</script>
<style scoped>
.review-process__item.selected,
.review-process__item:hover {
    background-color: #FFF4EE;
    border-color: var(--bs-primary);
    color: var(--bs-primary);
}

.review-process__btn .button {
    max-width: 50%;
}

.review-process__btn {
    justify-content: space-around;
}

.review-process__item {
    justify-content: flex-start;
    position: relative;
    width: fit-content;
}

.review-process__list {
    flex-wrap: wrap;
    flex-direction: column;
    align-content: flex-start;
    justify-content: flex-start;
    margin: 15px -4px 15px;
}

i.icon-fonts.icon-fonts--star-2 {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.text-star {
    font-size: 13px;
    font-style: normal !important;
    margin-top: 4px;
    white-space: nowrap;
}

.rating-vote__action .icon-fonts {
    font-size: 33px;
    margin-top: 10px;
    width: 60px;
}

.rating-vote__action .icon-fonts span{
  color: black;
}

.rating-vote__action .icon-fonts .active{
   color: #C6110C;
}


.modal-custom__body {
    padding: 20px;
}

.rating-vote__des {
    font-size: 17px;
    font-weight: 500;
    color: black;
}

.modal-custom__content {
    padding: 0;
}

span.text-header {
    width: 55%;
    font-size: 14px;
    font-weight: bold;
    text-align: left;
}

span.text-header span {
    color: var(--bs-primary);
}

.img-sr {
    position: absolute;
    right: 15%;
    bottom: 0px;
}

.img-u {
    position: absolute;
    top: 10%;
}

.review-process__tick {
    position: absolute;
    right: 0px;
    background: var(--bs-primary);
    top: 0pc;
    border-radius: 0 5px 0 5px;
    height: 10px;
    color: #fff;
    font-size: 10px;
}

.modal-custom__header {
    position: relative;
    background-image: url('../../../assets/images/rating.svg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: 135px;
    display: flex;
    align-items: center;
    padding: 15px;
    border-radius: 11px 11px 0px 0px;
    justify-content: flex-start;
    align-items: flex-end;
}

.modal-custom__action {
    position: absolute;
    right: 15px;
    /* Căn lề trái */
    top: 25px;
    transform: translateY(-50%);
    /* Căn giữa theo chiều dọc */
    cursor: pointer;
    font-size: 20px;
    /* Điều chỉnh kích thước icon */
    color: var(--bs-primary);
    /* Đổi màu icon nếu cần */
}

.review-process__tick {
    position: absolute;

}
</style>